import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const ProductOptionValuesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  wrapsOptionsListArray,
  selectedRow,
  can_create,
  optionTypesOptions,
  filterProductsOptionTypes,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [supportedLang, setSupportedLang] = useState("en");
  const [optionType, setOptionType] = useState();
  const optionsTypes = useSelector(
    (state) => state.productsOptionTypes.productsOptionTypes,
  );
  useEffect(() => {
    const filteredData = filterProductsOptionTypes?.find(
      (ele) => ele?.id === selectedRow?.formikData?.values?.option_type_id,
    );
    setOptionType(filteredData?.name || details?.option_type?.name);
  }, [selectedRow?.formikData?.values?.option_type_id, details]);
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("products_option_values.title"),
            data: {
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data, // data
            listTitle: t("products_option_values.title"), //title
            createBtnTitle: can_create && t("products_option_values.add"), // action
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "image",
                Header: t("products_option_values.product"),
              },
              {
                accessor: "option_type.name",
                Header: t("products_option_values.option_type"),
                sort: true,
                sortKey: "type",
              },
              {
                accessor: "localized_data.en.name",
                Header: t("products_option_values.option_value_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("products_option_values.option_value_ar"),
                sort: true,
              },

              {
                accessor: "presentation",
                Header: t("products_option_values.presentation"),
                sort: true,
              },
              {
                accessor: "approval_status",
                Header: t("products_option_values.approval_status"),
              },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t(
              "products_option_values.search_placeholder",
            ),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "organization-table system-configurations-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // lw mafesh id add mafesh values -------- lw fe id yb2a edit values
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () =>
              structure(
                optionsTypes,
                optionType,
                optionTypesOptions,
                details,
                t,
              ),
            validationSchema: validationSchema(optionType, t),
            deleteFun: deleteFun,
            title: id
              ? t("products_option_values.edit")
              : t("products_option_values.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default ProductOptionValuesTemplate;
